'use strict';

angular.module('casist.search', []);